<template>
  <div style="width: 100%; height: 100%">
    <div v-if="camera.deviceType != 3" style="width: 100%; height: 100%; display: flex">
      <div class="easyplayerVideo" v-if="videoUrl" :style="{ width: camera.width, height: camera.height, 'line-height': camera.height }">
        <EasyPlayer :videoUrl="videoUrl" fluent autoplay live stretch :hasAudio="false"></EasyPlayer>
      </div>
      <div
        class="easyplayerVideo"
        v-else
        :style="{ width: camera.width, height: camera.height, 'line-height': camera.height, display: 'flex' }"
        style="align-items: center; justify-content: center; font-size: 1.1vw"
      >
        {{ videoText }}
      </div>
    </div>
    <div v-else :style="{ width: camera.width, height: camera.height, background: '#000' }">
      <iframe
        :style="{ width: camera.width, height: camera.height, background: '#000' }"
        allow="autoplay *; microphone *; fullscreen *"
        allowfullscreen="true"
        allowtransparency="true"
        allowusermedia="true"
        frameBorder="no"
        :src="videoUrl"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import EasyPlayer from '@easydarwin/easyplayer';
import { getVideoHlsUrlToWeb } from '@/api/device';
export default {
  props: ['camera'],
  data() {
    return {
      videoUrl: '',
      videoText: ''
    };
  },
  components: {
    EasyPlayer
  },
  created() {
    let data = {};
    if (this.camera.deviceNo) {
      data = {
        deviceNo: this.camera.deviceNo
      };
    } else {
      data = {
        deviceId: this.camera.deviceId
      };
    }

    console.log(this.camera, '我是视频组件 camera', data);
    if (this.camera.type) {
      getVideoHlsUrlToWeb(data, 'apiHttp').then(res => {
        if (res.data.code == 0) {
          this.videoUrl = res.data.data;
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          });
          this.videoText = res.data.msg;
        }
      });
    } else {
      let calldata = {};
      if (this.camera.deviceNo) {
        calldata = {
          deviceNo: this.camera.deviceNo,
          startTime: this.camera.history_date[0],
          endTime: this.camera.history_date[1]
        };
      } else {
        calldata = {
          deviceId: this.camera.deviceId,
          startTime: this.camera.history_date[0],
          endTime: this.camera.history_date[1]
        };
      }
      getVideoHlsUrlToWeb(calldata, 'apiHttp').then(res => {
        if (res.data.code == 0) {
          this.videoUrl = res.data.data;
        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          });
          this.videoText = res.data.msg;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.easyplayerVideo {
  background: #000;
  text-align: center;
  color: #fff;
}
.easy-player-loading img {
  display: none;
}
.easy-player-right-menu {
  display: none !important;
}
.vjs-control,
.vjs-button,
.vjs-snapshot-control {
  display: none;
  width: 0;
}
.easy-player-loading-text {
  display: none;
}
.icon-snapshot:before {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/easyplayerVideo.vue